import { Dimensions4 } from '@efexteam/design-tokens';
import { css } from '@emotion/css';

const searchBar = css({
  '&.MuiFormControl-root': {
    maxWidth: '400px',
  },
});

const searchBarIcon = css({
  '&.MuiSvgIcon-root': {
    width: Dimensions4,
    height: Dimensions4,
  },
});

const SearchBarStyles = {
  searchBar,
  searchBarIcon,
};

export default SearchBarStyles;
